<script setup lang="ts">
import * as Sentry from '@sentry/vue'
import { onErrorCaptured, ref } from 'vue'
import { useI18n } from 'vue-i18n'

// Contains a render/lifecycle error to whatever this wraps (e.g. one router page) instead of
// letting it unmount the whole app, so the nav/tab router around it stays usable. Returning
// false stops the error before app.config.errorHandler, which is where Sentry's Vue integration
// hooks in, so it has to be reported here (a no-op when Sentry is not initialised).
const { t } = useI18n()
const failed = ref(false)
const remountKey = ref(0)

onErrorCaptured((error) => {
  failed.value = true
  Sentry.captureException(error)
  console.error('ErrorBoundary caught:', error)
  return false
})

function retry(): void {
  failed.value = false
  remountKey.value++
}
</script>

<template>
  <div v-if="failed" class="error-boundary">
    <p>{{ t('error.pageFailed') }}</p>
    <button type="button" class="ui-btn" @click="retry">{{ t('common.retry') }}</button>
  </div>
  <slot v-else :remount-key="remountKey" />
</template>

<style scoped>
.error-boundary {
  padding: 2rem 1rem;
  text-align: center;
}

.error-boundary p {
  color: var(--tg-hint-color);
  margin-bottom: 0.75rem;
}
</style>
